const LeadListClick = (($) => {
    $(document).ready(function () {
        $('.table__row[data-href]').on('click', function (event) {
            let href = $(this).data('href');
            if (href) {
                document.location.href = href;
            }
        });
    });
})(jQuery);

// export default LeadListClick
